var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApprove = function SvgApprove(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0451 4.20154C13.3018 4.41103 13.3401 4.78899 13.1306 5.04574L7.96333 11.3787C7.95721 11.3863 7.9509 11.3936 7.94442 11.4008C7.62667 11.7539 7.22865 11.9814 6.75267 11.9612C6.3156 11.9427 5.93521 11.7172 5.62363 11.468C5.61673 11.4624 5.60996 11.4568 5.60332 11.451L2.9373 9.11795C2.68793 8.89973 2.66268 8.52067 2.8809 8.2713C3.09913 8.02193 3.47819 7.99668 3.72756 8.2149L6.38308 10.5387C6.61687 10.7239 6.74737 10.7599 6.8035 10.7623C6.80384 10.7623 6.80419 10.7623 6.80457 10.7624C6.82401 10.7633 6.89765 10.7666 7.04362 10.6078L12.2009 4.28711C12.4104 4.03036 12.7883 3.99205 13.0451 4.20154Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApprove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "approve.cd33e950157bc2fae2266a05f847743a.svg";